// config/subscriptionPlans.js
export const subscriptionPlans = {
    basic: {
        id: "basic",
        name: "Basic",
        price: "15900",
        interval: "quarterly",    
        periodLength: 90,        
        periodCredits: 2,         
        features: {
            maxSessionDuration: 2,    
            photosPerHour: 25,
            editingType: "basic",
            deliveryTime: "7 days",
            extras: [
                "2 hours of session credits per quarter",
                "Up to 2 hours per session",
                "10 photos per hour",
                "Basic photo editing",
                "Digital downloads",
                "Online gallery access"
            ],
            addOnCredits: {
                "limit": 4,       
                "price": 2500      
            }
        },
        restrictions: {
            bookingWindow: 14,    // Can book 14 days in advance
            minSessionDuration: 1,
            nextPlanChange: 90    // Days before plan change allowed
        }
    },
    premium: {
        id: "premium",
        name: "Premium",
        price: "17900",
        interval: "bimonthly",    
        periodLength: 60,         
        periodCredits: 3,         
        features: {
            maxSessionDuration: 2,    
            photosPerHour: 35,
            editingType: "advanced",
            deliveryTime: "5 days",
            extras: [
                "3 hours of session credits per 2 months",
                "Up to 2 hours per session",
                "20 photos per hour",
                "Advanced photo editing",
                "Priority booking",
                "Digital downloads",
                "Online gallery access",
                "Bi-monthly digital album"
            ],
            addOnCredits: {
                limit: 6,        
                price: 2000      
            }
        },
        restrictions: {
            bookingWindow: 21,    // Can book 21 days in advance
            minSessionDuration: 1,
            nextPlanChange: 60    // Days before plan change allowed
        }
    },
    vip: {
        id: "vip",
        name: "VIP",
        price: "11900",
        interval: "monthly",
        periodLength: 30,        
        periodCredits: 2,        
        features: {
            maxSessionDuration: 2,
            photosPerHour: 50,
            editingType: "premium",
            deliveryTime: "72 hours",
            extras: [
                "2 hours of session credits per month",
                "Up to 2 hours per session",
                "30 photos per hour",
                "Premium photo editing",
                "Priority booking",
                "Emergency sessions",
                "Home visits available",
                "Digital downloads",
                "Online gallery access",
                "Monthly mini sessions included"
            ],
            addOnCredits: {
                limit: 5,        // Can buy up to 4 extra hours per month
                price: 1000      // per hour
            }
        },
        restrictions: {
            bookingWindow: 30,    // Can book 30 days in advance
            minSessionDuration: 1,
            nextPlanChange: 30    // Days before plan change allowed
        }
    }
};

// Add helper functions for plan calculations
export const getPlanPeriodLength = (planId) => {
    return subscriptionPlans[planId]?.periodLength || 30;
};

export const calculateNextRenewalDate = (startDate, planId) => {
    const periodLength = getPlanPeriodLength(planId);
    const date = new Date(startDate);
    return new Date(date.setDate(date.getDate() + periodLength));
};

export const calculateProratedCredits = (planId, daysLeft) => {
    const plan = subscriptionPlans[planId];
    if (!plan) return 0;
    return Math.round((plan.periodCredits * daysLeft) / plan.periodLength);
};

export const getPlanInterval = (planId) => {
    const intervals = {
        quarterly: "every 3 months",
        bimonthly: "every 2 months",
        monthly: "monthly"
    };
    return intervals[subscriptionPlans[planId]?.interval] || "monthly";
};